module.exports = __webpack_public_path__ + "static/media/gear.af3df55e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/gear.svg
// module id = 455
// module chunks = 0